export default {
    start: 'find-sales-receipt',
    process: require('./../process/carrefour').default
}



// WEBPACK FOOTER //
// ./src/processes/conf/carrefour.js